// Marketing expenses total = Advertising + Other expenses (Michael Piccoli, DOMA
// 13235163189). The marketing-package "Selected items total" fills Advertising;
// this keeps the printed Marketing total in step with Advertising + Other.

// Parse a stored currency string ("1,234.5", "$1234") to a number; 0 if blank.
export const parseMoney = (s) =>
  Number(String(s ?? "").replace(/[^0-9.]/g, "")) || 0;

// The computed total as the plain numeric string the currency field stores
// (no $, no commas), or "" when the sum is zero/blank.
export function computeMarketingTotal(advertising, otherExpenses) {
  const sum = parseMoney(advertising) + parseMoney(otherExpenses);
  return sum ? String(Math.round(sum * 100) / 100) : "";
}
